import "intersection-observer";
import React, { Component } from "react";

const LazyLoader = (WrappedComponent, onlyImage = true, lazyLoadOptions) => {
  return class LazyLoadImage extends Component {
    state = {
      showComponent: onlyImage
    };

    lazyLoaderRef = React.createRef();
    observer = null;

    componentDidMount() {
      try {
        const { showComponent } = this.state;

        if ("IntersectionObserver" in window) {
          const options = {
            rootMargin: "0px",
            ...lazyLoadOptions
          };

          this.observer = new IntersectionObserver(
            this.observerCallback,
            options
          );

          if (showComponent) {
            const allImages = this.lazyLoaderRef.current.querySelectorAll(
              "[data-src], [data-srcset]"
            );

            allImages.forEach(image => {
              if (!image.getAttribute("src") && !image.getAttribute("srcset")) {
                this.observer.observe(image);
              }
            });
          } else {
            const targetElement = this.lazyLoaderRef.current;
            this.observer.observe(targetElement);
          }
        } else {
          console.log("IntersectionObserver is not supported");
          this.fallback();
        }
      } catch (err) {
        console.log(err);
        this.fallback();
      }
    }

    componentWillUnmount() {
      if (this.observer) {
        this.observer.disconnect();
      }
    }

    observerCallback = (entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          if (this.state.showComponent) {
            this.loadImage(entry.target);
          } else {
            this.loadComponent();
          }
          observer.unobserve(entry.target);
        }
      });
    };

    loadImage = img => {
      if (img.getAttribute("data-src")) {
        img.src = img.getAttribute("data-src");
      }

      if (img.getAttribute("data-srcset")) {
        img.srcset = img.getAttribute("data-srcset");
      }
    };

    loadComponent = () => {
      this.setState({ showComponent: true });
    };

    fallback = () => {
      const allImages = this.lazyLoaderRef.current.querySelectorAll(
        "[data-src], [data-srcset]"
      );

      allImages.forEach(image => this.loadImage(image));
      // this.loadComponent();
    };

    render() {
      const { showComponent } = this.state;

      return (
        <div ref={this.lazyLoaderRef}>
          {showComponent ? <WrappedComponent {...this.props} /> : null}
        </div>
      );
    }
  };
};

export default LazyLoader;
